import { render, staticRenderFns } from "./FormButton.vue?vue&type=template&id=25c93126&scoped=true"
import script from "./FormButton.vue?vue&type=script&lang=ts"
export * from "./FormButton.vue?vue&type=script&lang=ts"
import style0 from "./FormButton.vue?vue&type=style&index=0&id=25c93126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c93126",
  null
  
)

export default component.exports